import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ICharge,
  IChargeForSelect,
  ICredit,
  ICreditForSelect,
  IRiderPayorInformation
} from '../../../../../../core/interfaces/billing.interface';
import { ComunicationEditBilling } from '../../comunication-edit-billing';
import { Subscription } from 'rxjs/Subscription';
import { BillingEditService } from '../../../../../../core/services/billing-edit.service';
import { constant } from '../../../../../../app.constants';
import { IMyDateModel, IMyOptions } from 'mydatepicker';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-create-charges-credits',
  templateUrl: './create-charges-credits.component.html',
  styleUrls: ['./create-charges-credits.component.scss']
})
export class CreateChargesCreditsComponent implements OnInit, OnDestroy {

  loading = false;
  public form: FormGroup;
  public chargesType: IChargeForSelect[];
  public creditsType: ICreditForSelect[];
  public payors: IRiderPayorInformation[];
  public credit: boolean;
  public subscriptions: Subscription[] = [];
  public cptManual = false;
  public chargeSelected: IChargeForSelect;
  public maskDate = constant.MASK_DATE_DMY;
  public myDatePickerOptions: IMyOptions = {
    firstDayOfWeek: 'su',
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true,
  };
  @Input() tripid: number;
  @Input() chargeSelectedByTrip: ICharge;
  @Input() creditSelectedByTrip: ICredit;
  private creditDenial = 19;

  constructor(
    private fb: FormBuilder,
    private service: BillingEditService,
    public communication: ComunicationEditBilling,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
  }

  ngOnInit() {
    this.createForm();
    this.form.get('tripid').setValue(this.tripid);
    this.getChargesAndCredits(this.tripid, this.communication.credit);
    if (this.communication.credit) { this.getPayors(this.communication.riderid); }
    this.setValueFormCharge();
  }

  /**@name createForm
   * @description crea el formulario corespondiente.
   */
  createForm() {
   switch (this.communication.credit) {
     case true: { this.createFormCreditTrip(); }
       break;
     case false: {this.createFormChargeTrip(); }
       break;
   }
  }

  setValueFormCharge() {
    if (Object.keys(this.chargeSelectedByTrip).length) {
      this.form.patchValue({
        tripchargeid: this.chargeSelectedByTrip.tripchargeid,
        chargeid: this.chargeSelectedByTrip.charge.chargeid,
        cpt: this.chargeSelectedByTrip.cpt,
        units: this.chargeSelectedByTrip.units,
        unitamount: this.chargeSelectedByTrip.unitamount,
        amount: this.chargeSelectedByTrip.amount
      });
      this.cptManual = true;
      this.validControlOfCharge(this.cptManual);
      this.form.get('cpt').setValidators(Validators.required);
      this.listenFormCharge(true);
      this.form.get('chargeid').disable();
    }
  }

  /**@name createFormChargeTrip
   * @description crea el formulario para los crages
   */
  createFormChargeTrip() {
    this.form = this.fb.group({
      tripchargeid: undefined,
      tripid: undefined,
      chargeid: [undefined, [Validators.required]],
      units: [undefined, [Validators.required]],
      amount: undefined,
      cpt: undefined,
      unitamount: [undefined, [Validators.required]],
      isnegotiated: false,
      modifiedon: undefined,
      addedon: undefined,
    });
    this.setControlEnable('cpt', false);
    this.setControlEnable('units', false);
    this.setControlEnable('unitamount', false);
    this.setControlEnable('amount', false);
    if (!this.chargeSelectedByTrip.chargeid && !this.creditSelectedByTrip.creditid) {
      this.listenFormCharge();
    }

  }
  listenFormCharge(edit?: boolean) {
    this.subscriptions.push(this.form.get('chargeid').valueChanges.subscribe(
      (chargeid: number) => {
        if (chargeid) {
          this.selectCptOfChange(chargeid, edit);
        }
      }
    ));
    this.subscriptions.push(this.form.get('unitamount').valueChanges.subscribe(
      val => {
        this.setAmount(val);
      }
    ));
    this.subscriptions.push(this.form.get('units').valueChanges.subscribe(
      val => {
        this.setAmount(val);
      }
    ));
    this.subscriptions.push(this.form.get('cpt').valueChanges.subscribe(
      (value: string) => {
        if (value && value !== value.toUpperCase()) {
          this.form.get('cpt').setValue(value.toUpperCase());
        }
      }
    ));
  }
  /**@name createFormCreditTrip
   * @description crea el formulario para los credit
   */
  createFormCreditTrip() {
    this.form = this.fb.group({
      tripid: undefined,
      payorid: [undefined, [Validators.required]],
      creditid: [undefined, [Validators.required]],
      tripcreditid: undefined,
      amount: [undefined, [Validators.required]],
      tripchargeid: undefined,
      checknumber: undefined,
      checkdate: undefined,
      modifiedon: undefined,
      addedon: undefined,
      depositdate: undefined,
      denialcode: ['', Validators.required],
      modifier: [null],
      claimno: [null],
      procd: [null]
    });
  }

  /**@name selectCptOfChange
   * @description pasa el charge selecionado y llama metodo para verificar cpt a pasar
   */
  selectCptOfChange(chargeid: number, edit: boolean) {
    if (!edit) {
      this.cptManual = false;
      this.chargesType.forEach(
        (charge: IChargeForSelect) => {
          if (charge.chargeid === chargeid) {
            this.resetFormCharge();
            this.chargeSelected = charge;
            this.verifyChargeCPTBaseByTrip(charge);
          }
        }
      );
    }
  }

  verifyAndSetCharge(charge: IChargeForSelect) {
    if (charge.feeschedulecharge) {
      this.form.get('cpt').setValue(charge.cptbase);
    } else {
      this.form.get('cpt').setValue(charge.cpt);
    }
    if (charge.chargetypeid === 1) {
      this.form.patchValue({
        units: 1,
        unitamount: charge.rate.basecharge ? charge.rate.basecharge : '',
      });
    }else if (charge.chargetypeid === 2) {
      /************** setear valor para millas, pendiente valor milla feescheduled ********************/
      this.form.patchValue({
        units: charge.totalmiles,
        unitamount: charge.totalamount / charge.totalmiles,
      });
    }
    this.validControlOfCharge(this.cptManual);
  }

  /**@name verifyChargeCPTBaseByTrip
   * @description verifica
   * @param charge = id del trip
   */
  verifyChargeCPTBaseByTrip(charge: IChargeForSelect) {
    let next: boolean;
    if (this.communication.chargesByTrip.length) {
      this.communication.chargesByTrip.forEach(
        (chargeByTrip: ICharge) => {
          if (chargeByTrip.charge.chargeid === charge.chargeid) {
            next = true;
          }
        }
      );
      if (next) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Add Charge',
          text: 'There is already a base charge added to the trip. Do you want to add another one.',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          allowOutsideClick: false
        }).then(
          resul => {
            if (resul.dismiss) {
              this.form.get('chargeid').setValue('');
              this.resetFormCharge();
            }else if (resul.value) {
              this.verifyAndSetCharge(charge);
            }
          }
        );
      }else if (charge.chargetypeid === 3) {
        this.verifyAndSetCharge(charge);
      }
    }else {
      this.verifyAndSetCharge(charge);
    }
  }


  /**@name resetFormCharge
   * @description resetea campos del formulario de charge
   */
  resetFormCharge() {
    this.form.patchValue({
      units: '',
      amount: '',
      unitamount: '',
      cpt: ''
    });

    this.setControlEnable('cpt', false);
    this.setControlEnable('units', false);
    this.setControlEnable('unitamount', false);
    this.setControlEnable('amount', false);
  }
  /**@name getCharges
   * @description trae los charges para el select de charges
   * @param tripId = id del trip
   */
  getCharges(tripId: number) {
    this.service.getChagesForSelect(tripId)
      .toPromise()
      .then(
        (success: IChargeForSelect[]) => {
          this.chargesType = success;
        }
      );
  }

  /**@name getCredits
   * @description trae los credits para el select de credits
   */
  getCredits() {
    this.service.getCreditForSelect()
      .toPromise()
      .then(
        (credits: ICreditForSelect[]) => {
          this.creditsType = credits;
        }
      );
  }

  /**@name getChargesAndCredits
   * @description llama servicio para traer charges o chedits segun credit
   * @param tripId = id del trip
   * @param credit = is credit
   */
  getChargesAndCredits(tripId: number, credit: boolean) {
    switch (credit) {
      case true: {this.getCredits(); }
      break;
      case false: {this.getCharges(tripId); }
    }
  }

  /**@name getPayors
   * @description llama servicio para traer los payors
   * @param riderId = id del rider
   */
  getPayors(riderId: number) {
    this.service.getPayorsTrip(riderId)
      .toPromise()
      .then(
        (success: IRiderPayorInformation[]) => {
          this.payors = success;
          this.payors.forEach(
            (payor: IRiderPayorInformation) => {
              if (payor.isdefault) {
                this.form.get('payorid').setValue(payor.payorid);
              }
            }
          );
        }
      );
  }
  /**@name onSave
   * @description crea charge o credit para el trip
   */
  onSave() {
    this.loading = true;
    const data = this.form.getRawValue();
    switch (this.communication.credit) {
      case true:
        if (data.tripcreditid) {
          this.service.updateTripCredit(data)
            .finally(() => this.loading = false)
            .toPromise()
            .then(
              success => {
                this.saveSuccess(success);
              }, () => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Credit Update',
                  text: 'An error was generated when trying to update this Credit!',
                  type: 'error'
                }).then();
              }
            );
        } else {
          this.service.createTripCredit(data)
            .finally(() => this.loading = false)
            .toPromise()
            .then(
              success => {
                this.saveSuccess(success);
              }, () => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Add a Credit',
                  text: 'An error was generated when trying to add a Credit!',
                  type: 'error'
                }).then();
              }
            );
        }
        break;
      case false:
        if (data.tripchargeid) {
          this.service.updateTripCharge(data)
            .finally(() => this.loading = false)
            .toPromise()
            .then(
              success => {
                this.saveSuccess(success);
              }, () => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Credit Charge',
                  text: 'An error was generated when trying to update this Charge!',
                  type: 'error'
                }).then();
              }
            );
        } else {
          this.service.createTripCharge(data)
            .finally(() => this.loading = false)
            .toPromise()
            .then(
              success => {
                this.saveSuccess(success);
              }, () => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Add a Charge',
                  text: 'An error was generated when trying to add a Charge!',
                  type: 'error'
                }).then();
              }
            );
        }
        break;
    }
  }

  /**@name saveSuccess
   * @description
   * @param data
   */
  saveSuccess(data) {
    this.communication.upDateBilling.next(true);
    this.onClose();
    this.message('success', data.message);
  }

  /**@name onClose
   * @description pasa valor false para cerrar la modal
   */
  onClose() {
    this.communication.openCreate.next(false);
  }

  /**@name onChangeCPTmanual
   * @description cambia cptManual y llama metodos para verificación
   */
  onChangeCPTmanual() {
    if (this.form.get('chargeid').value) {
      this.cptManual = !this.cptManual;
      this.validControlOfCharge(this.cptManual);
      this.verifyIsFeescheduled(this.cptManual);
      this.form.get('isnegotiated').setValue(this.cptManual);
    }
  }

  /**@name validControlOfCharge
   * @description enable or disabled the control
   */
  validControlOfCharge(manual: boolean) {
    this.setControlEnable('cpt', manual);
    this.setControlEnable('units', manual);
    this.setControlEnable('unitamount', manual);
  }

  /**@name setControlEnable
   * @description enable or disabled the control
   */
  setControlEnable(control: string, enable: boolean) {
    const absControl: AbstractControl = this.form.get(control);
    enable ? absControl.enable() : absControl.disable();
  }

  /**@name setAmount
   * @description setea el valor del amount
   * @param val = valor unitamount
   */
  setAmount(val: number) {
    let value;
    const unit = this.form.get('units').value;
    const unitamount = this.form.get('unitamount').value;
    if (val) {
        value = unit * unitamount;
    }else {
      value = '';
    }
    this.form.get('amount').setValue(value);
  }

  /**@name verifyIsFeescheduled
   * @description si feeschedulecharge muestra pregunta
   * @param cptManual = si se modificara el charge de forma manual
   */
  verifyIsFeescheduled(cptManual: boolean) {
    if (cptManual) {
      if (this.chargeSelected.feeschedulecharge) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Modify Charge',
          text: 'This Charge  set in Payor FeeSchedule.... Do you want change anyway?',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          allowOutsideClick: false
        }).then(
          result => {
            if (result.dismiss) {
              this.onChangeCPTmanual();
            }
          }
        );
      }
    }
  }

  message(type: any, message?: string, title?: string) {
    switch (type) {
      case 'success':
        this.sweetAlertHelper.createCustomAlert({
          title: title ? title : 'Successful',
          text: message ? message : 'Successful Action',
          type: 'success'

        }).then();
        break;
    }
  }

  onDateSet(date: IMyDateModel, dateType: number) {
    dateType === 1 ? this.form.get('checkdate').setValue(date.formatted) : this.form.get('depositdate').setValue(date.formatted);
  }

  onChangeChrg(chrg) {
    const split = chrg.split(':');
    const chargesTrip = this.communication.chargesByTrip.find(item => item.tripchargeid === Number(split[1]));
    this.form.get('amount').setValue(chargesTrip.amount);
  }

  get onChangeCredit() {
    this.form.get('denialcode').setValue(null);
    const credit =  this.form.get('creditid').value;
    return  credit !== 19 ? this.setValidators('denialcode', []) : this.setValidators('denialcode', [Validators.required]);
  }

  setValidators(control: string, required) {
    this.form.controls[control].setValidators(required);
    this.form.controls[control].updateValueAndValidity();
  }

  get creditIsDenial(): boolean {
    return this.form.get('creditid').value === this.creditDenial;
  }

  get classCreditIsDenial(): string {
    return this.creditIsDenial ? 'row-16' : 'row-20' + ' padding-l-5';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscribe: Subscription) => subscribe.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/components/create-charges-credits/create-charges-credits.component.ts